import { useEffect, useState, useCallback } from 'react';
import { UploadProgressManager } from '../services';

export function useUploadProgress() {
  const [uploadState, setUploadState] = useState(() => UploadProgressManager.getState());

  useEffect(() => {
    return UploadProgressManager.subscribe(setUploadState);
  }, []);

  const requestRestore = useCallback(() => UploadProgressManager.requestRestore(), []);

  return {
    ...uploadState,
    requestRestore,
    getUploadTypeTitle: UploadProgressManager.getUploadTypeTitle.bind(UploadProgressManager),
  };
}

export default useUploadProgress;
